import {
  ERROR_WIDGET,
  ErrorWidget,
} from './components/ChatMessageWidgets/ErrorWidget';
import {
  TEXT_WIDGET,
  TextChatWidget,
} from './components/ChatMessageWidgets/TextChatWidget';
import type { InterpertedChatMessage, ChatMessageWidget } from './types';

const emptyTextWidget: InterpertedChatMessage = {
  widget: TextChatWidget.displayName || TEXT_WIDGET,
  data: { message: '' },
};

export const parseChatMessage = (
  message: string,
  widgets: ChatMessageWidget[],
): InterpertedChatMessage[] => {
  if (!message) {
    return [emptyTextWidget];
  }

  const parsedItems: InterpertedChatMessage[] = [];

  for (const match of message.match(/<<(.*?)>>|([^<]+)/gs) || []) {
    const isWidget = match.startsWith('<<') && match.endsWith('>>');
    if (isWidget) {
      const widgetStr = match.slice(2, match.length - 2).trim();
      if (widgetStr) {
        const interpretedMessage = parseWidget(widgetStr, widgets);
        if (interpretedMessage) {
          if (interpretedMessage.widget === ERROR_WIDGET) {
            throw new Error(interpretedMessage.data.message);
          }
          parsedItems.push(interpretedMessage);
        }
      }
      continue;
    }

    const textStr = match.trim();
    if (textStr) {
      parsedItems.push({
        widget: TextChatWidget.displayName || TEXT_WIDGET,
        data: { message: textStr },
      });
    }
  }

  return parsedItems;
};

const parseWidget = (
  widgetStr: string,
  widgets: ChatMessageWidget[],
): InterpertedChatMessage | undefined => {
  let widgetName = '';
  let widgetData;
  let widgetConfig;
  try {
    const jsonData = JSON.parse(widgetStr);
    widgetName = jsonData.widget;
    widgetData = jsonData.data;
    widgetConfig = jsonData.config;
  } catch (error) {
    widgetName = widgetStr;
    widgetData = {};
    widgetConfig = undefined;
  }
  const widgetComponent = widgets.find(
    (widget) => widget.widgetName === widgetName,
  );

  if (!widgetComponent) {
    return {
      widget: ERROR_WIDGET,
      data: {
        message: `Widget ${widgetName} not found`,
      },
      component: ErrorWidget,
    };
  }

  if (!widgetComponent.component) {
    return undefined;
  }

  return {
    widget: widgetName,
    data: widgetData,
    component: widgetComponent.component,
    config: widgetConfig,
  };
};
